import React from 'react';
import { Checkbox } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';

/**
 * The mark in front of a question number in the rail: a tick or a cross once
 * the quiz has been graded, and a read-only checkbox while it is being taken,
 * which fills in as soon as the question has an answer.
 *
 * It is decorative either way — the rail item carries the wording for screen
 * readers — so it is hidden from them here.
 *
 * Props:
 *   isGraded   (bool) - Whether the quiz has been submitted.
 *   isCorrect  (bool) - Whether the answer was right. Graded quizzes only.
 *   isAnswered (bool) - Whether the question has been answered.
 */
export const ChecklistMarker = ({ isGraded, isCorrect, isAnswered }) => {
  if (isGraded) {
    return (
      <FontAwesomeIcon icon={isCorrect ? faCheck : faXmark} className="checklistMark" aria-hidden />
    );
  }

  return (
    <Checkbox
      className="checklistCheckbox"
      checked={isAnswered}
      disabled
      size="small"
      tabIndex={-1}
      slotProps={{ input: { 'aria-hidden': true } }}
    />
  );
};
